$(document).ready(function() {
   var $PopupSale = $('.popup-sale');
   var time = $PopupSale.data('time') || 0;
   var cookiePS = 'cookieSuggest';
   var $ClosePS = $('.close-ps');
      
  function ShowPopup() {
    function ShowPopupRun() {
      var PSproductlist = $('.ps-product-list');
      var PSmixproduct = Math.floor(Math.random() * PSproductlist.length);
      var PSitem = $(PSproductlist[PSmixproduct]);
      if($PopupSale.hasClass('active')){
        $PopupSale.removeClass('active');
      }
      else{
        $PopupSale.addClass('active');
        $PopupSale.find('.product-popup-image').attr('href', PSitem.data('url')).find('img').attr('src', PSitem.data('image'));
        $PopupSale.find('.product-popup-name').text(PSitem.data('title')).attr('href', PSitem.data('url'));
        $PopupSale.find('.time-bought').text(PSitem.data('time'));
        $PopupSale.find('.local-bought').text(PSitem.data('local'));
      }
    }
    if ($.cookie(cookiePS) == 'closed') {
      $PopupSale.remove();
    }   
    $ClosePS.on('click',function(){
      $PopupSale.remove();
      $.cookie(cookiePS, 'closed', {expires:1, path:'/'});
    });  
    if (time !== 0){
      setInterval(ShowPopupRun, time);
    }
  }
  ShowPopup();
});